/**
 * Clube Coffee++ - Assinatura Mensal (Setembro 2026)
 * Mecânica de Catálogo, Calculadora, Modal Sensorial, Minicarrinho e Checkout
 */
"use strict";

class Produto {
  constructor(id, nome, preco, precoOriginal, imagem, quantidade) {
    this.id = id;
    this.nome = nome;
    this.preco = preco;
    this.precoOriginal = precoOriginal;
    this.imagem = imagem;
    this.quantidade = quantidade;
  }
}

let casrtAssinatura = [];

// ==========================================
// JORNADA MENSAL → ANUAL (desligada por padrão)
// Liga no Theme Editor: "Mostrar jornada mensal → anual no carrinho"
// Preview HTML: data-jornada-anual="true" no body ou #produtos
// ==========================================
function jornadaAnualAtiva() {
  return document.querySelector("[data-jornada-anual='true']") != null;
}

function construirMapaCategoriaPorVariantId() {
  const mapa = {};
  const cards = document.querySelectorAll(".cacm-produto-card[data-id][data-categoria], .clube-produto-card[data-id][data-categoria]");
  cards.forEach((card) => {
    const id = card.getAttribute("data-id");
    const categoria = card.getAttribute("data-categoria");
    if (id && categoria) mapa[String(id)] = categoria;
  });
  return mapa;
}

function carrinhoTemDripOuCapsula() {
  const mapa = construirMapaCategoriaPorVariantId();
  return casrtAssinatura.some((p) => {
    const cat = mapa[String(p.id)];
    return cat === "drip" || cat === "capsula";
  });
}

function atualizarTextoDescontoEspecial() {
  if (!jornadaAnualAtiva()) return;
  const eh40 = carrinhoTemDripOuCapsula();
  const textoPopup = eh40 ? "40% OFF" : "25% OFF";
  const textoBanner = eh40 ? "Até 40% OFF + FRETE GRÁTIS" : "Até 25% OFF + FRETE GRÁTIS";

  const elPopup = document.getElementById("cacm-popup-desconto-valor");
  const elMinicart = document.getElementById("cacm-minicart-desconto-valor");
  const elCarrinho = document.getElementById("cacm-carrinho-desconto-valor");

  if (elPopup) elPopup.textContent = textoPopup;
  if (elMinicart) elMinicart.textContent = textoBanner;
  if (elCarrinho) elCarrinho.textContent = textoBanner;
}

function abrirPopupEspecial() {
  if (!jornadaAnualAtiva()) return;
  const popup = document.getElementById("cacm-popup-especial");
  if (popup) {
    atualizarTextoDescontoEspecial();
    fecharMinicart();
    fecharCarrinho();
    popup.classList.add("show");
    document.body.style.overflow = "hidden";
  }
}

function fecharPopupEspecial() {
  const popup = document.getElementById("cacm-popup-especial");
  if (popup) {
    popup.classList.remove("show");
    document.body.style.overflow = "";
  }
}

function salvarCarrinhoMigracaoERedirecionarAnual() {
  if (!jornadaAnualAtiva()) return;
  try {
    const payload = [];
    casrtAssinatura.forEach((item) => {
      const card = document.querySelector(`.cacm-produto-card[data-id="${item.id}"], .clube-produto-card[data-id="${item.id}"]`);
      const annualVariantId = card ? card.getAttribute("data-related-annual-variant-id") : null;
      if (annualVariantId) {
        payload.push({ id: annualVariantId, quantidade: item.quantidade });
      }
    });
    sessionStorage.setItem("carrinhoMigracaoMensalParaAnual", JSON.stringify(payload));
  } catch (e) {
    console.error("Erro ao salvar migração:", e);
  }
  const anualHref =
    document.querySelector("[data-url-anual]")?.getAttribute("data-url-anual") ||
    "https://coffeemais.com/pages/anual-clube-setembro-2026-apagar";
  window.location.href = anualHref;
}

function aplicarVisibilidadeJornadaAnual() {
  const ativa = jornadaAnualAtiva();
  document.querySelectorAll(".cacm-jornada-anual").forEach((el) => {
    if (el.id === "cacm-popup-especial") {
      if (!ativa) el.classList.remove("show");
      return;
    }
    el.hidden = !ativa;
  });
}

function configurarJornadaAnual() {
  aplicarVisibilidadeJornadaAnual();
  if (!jornadaAnualAtiva()) return;

  const btnQueroMinicart = document.getElementById("cacm-banner-quero-minicart");
  if (btnQueroMinicart) btnQueroMinicart.addEventListener("click", abrirPopupEspecial);

  const btnQueroCarrinho = document.getElementById("cacm-banner-quero-carrinho");
  if (btnQueroCarrinho) btnQueroCarrinho.addEventListener("click", abrirPopupEspecial);

  const btnFecharPopup = document.getElementById("cacm-popup-especial-fechar");
  if (btnFecharPopup) btnFecharPopup.addEventListener("click", fecharPopupEspecial);

  const overlayPopup = document.querySelector(".cacm-popup-especial__overlay");
  if (overlayPopup) overlayPopup.addEventListener("click", fecharPopupEspecial);

  const btnPopupEspecial = document.getElementById("cacm-popup-especial-botao");
  if (btnPopupEspecial) {
    btnPopupEspecial.addEventListener("click", salvarCarrinhoMigracaoERedirecionarAnual);
  }
}

// ==========================================
// PERSISTÊNCIA NO SESSIONSTORAGE
// ==========================================
function salvarCarrinhoNoSessionStorage() {
  try {
    sessionStorage.setItem("carrinhoAssinaturaMensal", JSON.stringify(casrtAssinatura));
  } catch (error) {
    console.error("Erro ao salvar carrinho no sessionStorage:", error);
  }
}

function recuperarCarrinhoDoSessionStorage() {
  try {
    const carrinhoSalvo = sessionStorage.getItem("carrinhoAssinaturaMensal");
    if (carrinhoSalvo) {
      const produtosRecuperados = JSON.parse(carrinhoSalvo);
      return produtosRecuperados.map(
        (p) => new Produto(p.id, p.nome, p.preco, p.precoOriginal, p.imagem, p.quantidade)
      );
    }
  } catch (error) {
    console.error("Erro ao recuperar carrinho do sessionStorage:", error);
  }
  return [];
}

// ==========================================
// TOAST FEEDBACK
// ==========================================
function mostrarToast(mensagem) {
  const toast = document.getElementById("cacm-toast");
  if (!toast) return;
  const toastMessage = toast.querySelector(".cacm-toast__message");
  if (toastMessage) toastMessage.textContent = mensagem;
  toast.classList.add("show");
  setTimeout(() => {
    toast.classList.remove("show");
  }, 3000);
}

function desabilitarBotaoTemporariamente(botao, tempo = 1500) {
  const textoOriginal = botao.textContent;
  botao.setAttribute("disabled", "true");
  botao.textContent = "Adicionado ✓";
  setTimeout(() => {
    botao.removeAttribute("disabled");
    botao.textContent = textoOriginal;
  }, tempo);
}

// ==========================================
// MINICART & HEADER
// ==========================================
function atualizarContadorHeader(totalItens) {
  const contador = document.getElementById("cacm-header-carrinho-contador");
  if (contador) {
    contador.textContent = totalItens.toString();
    if (totalItens > 0) {
      contador.classList.add("show");
    } else {
      contador.classList.remove("show");
    }
  }
}

function mostrarMinicart() {
  const minicart = document.querySelector(".cacm-minicartassinatura");
  if (minicart && casrtAssinatura.length > 0) {
    minicart.style.display = "block";
    minicart.classList.add("is-open");
    atualizarMinicart();
  }
}

function fecharMinicart() {
  const minicart = document.querySelector(".cacm-minicartassinatura");
  if (minicart) {
    minicart.style.display = "none";
    minicart.classList.remove("is-open");
  }
}

function atualizarMinicart() {
  const totalItens = casrtAssinatura.reduce((tot, p) => tot + parseInt(p.quantidade), 0);
  const totalPreco = casrtAssinatura.reduce((tot, p) => {
    const precoNum = parseFloat(p.preco.replace("R$", "").replace(",", ".").trim());
    return tot + (isNaN(precoNum) ? 0 : precoNum * parseInt(p.quantidade));
  }, 0);

  const freteFixo = totalItens > 0 ? 7.99 : 0;
  const totalComFrete = totalPreco + freteFixo;

  atualizarContadorHeader(totalItens);

  const resumoMinicart = document.querySelector(".cacm-minicartassinatura__resumo-valor");
  if (resumoMinicart) {
    resumoMinicart.textContent = `R$ ${totalComFrete.toFixed(2).replace(".", ",")} / ${totalItens} ${totalItens === 1 ? "item" : "itens"}`;
  }

  atualizarTextoDescontoEspecial();
}

function montarUrlCarrinho() {
  const baseUrl = "https://coffeemais.com/cart/";
  const parametros = casrtAssinatura.map((item) => `${item.id}:${item.quantidade}`).join(",");
  return baseUrl + parametros;
}

// ==========================================
// CARRINHO OFFCANVAS
// ==========================================
function abrirCarrinho() {
  const carrinhoOffcanvas = document.getElementById("cacm-carrinho-offcanvas");
  if (carrinhoOffcanvas) {
    carrinhoOffcanvas.classList.add("show");
    document.body.style.overflow = "hidden";
    renderizarProdutosCarrinho();
  }
}

function fecharCarrinho() {
  const carrinhoOffcanvas = document.getElementById("cacm-carrinho-offcanvas");
  if (carrinhoOffcanvas) {
    carrinhoOffcanvas.classList.remove("show");
    document.body.style.overflow = "";
  }
}

function renderizarProdutosCarrinho() {
  const container = document.getElementById("cacm-carrinho-produtos");
  if (!container) return;

  container.innerHTML = "";
  if (casrtAssinatura.length === 0) {
    container.innerHTML = '<p style="color: #999; text-align: center; padding: 40px 0;">Seu carrinho está vazio.</p>';
    atualizarResumoCarrinho();
    return;
  }

  casrtAssinatura.forEach((produto, index) => {
    const itemEl = document.createElement("div");
    itemEl.className = "cacm-carrinho-item";
    itemEl.setAttribute("data-index", index.toString());
    itemEl.innerHTML = `
      <img src="${produto.imagem}" alt="${produto.nome}" class="cacm-carrinho-item__imagem">
      <div class="cacm-carrinho-item__coluna-nome">
        <div class="cacm-carrinho-item__nome">${produto.nome}</div>
        <div style="font-size: 13px; color: #29cc40; font-weight: 600;">${produto.preco}</div>
      </div>
      <div class="cacm-carrinho-item__quantidade">
        <button class="cacm-carrinho-item__quantidade-botao" data-action="diminuir" aria-label="Diminuir">-</button>
        <span class="cacm-carrinho-item__quantidade-valor">${produto.quantidade}</span>
        <button class="cacm-carrinho-item__quantidade-botao" data-action="aumentar" aria-label="Aumentar">+</button>
      </div>
    `;
    container.appendChild(itemEl);
  });

  adicionarEventListenersQuantidadeCarrinho();
  atualizarResumoCarrinho();
  atualizarTextoDescontoEspecial();
}

function adicionarEventListenersQuantidadeCarrinho() {
  const container = document.getElementById("cacm-carrinho-produtos");
  if (!container) return;

  const botoes = container.querySelectorAll(".cacm-carrinho-item__quantidade-botao");
  botoes.forEach((btn) => {
    btn.addEventListener("click", (e) => {
      const action = e.target.dataset.action;
      const itemEl = e.target.closest(".cacm-carrinho-item");
      const index = parseInt(itemEl?.getAttribute("data-index") || "0");

      if (action === "aumentar") {
        aumentarQuantidadeCarrinho(index);
      } else if (action === "diminuir") {
        diminuirQuantidadeCarrinho(index);
      }
    });
  });
}

function aumentarQuantidadeCarrinho(index) {
  if (casrtAssinatura[index]) {
    casrtAssinatura[index].quantidade = (parseInt(casrtAssinatura[index].quantidade) + 1).toString();
    salvarCarrinhoNoSessionStorage();
    renderizarProdutosCarrinho();
    atualizarMinicart();
    mostrarToast("Quantidade atualizada!");
  }
}

function diminuirQuantidadeCarrinho(index) {
  if (casrtAssinatura[index]) {
    const qtd = parseInt(casrtAssinatura[index].quantidade);
    if (qtd > 1) {
      casrtAssinatura[index].quantidade = (qtd - 1).toString();
      salvarCarrinhoNoSessionStorage();
      renderizarProdutosCarrinho();
      atualizarMinicart();
      mostrarToast("Quantidade atualizada!");
    } else {
      casrtAssinatura.splice(index, 1);
      salvarCarrinhoNoSessionStorage();
      renderizarProdutosCarrinho();
      atualizarMinicart();
      mostrarToast("Produto removido do carrinho!");
      if (casrtAssinatura.length === 0) {
        setTimeout(fecharCarrinho, 1200);
      }
    }
  }
}

function atualizarResumoCarrinho() {
  const totalItens = casrtAssinatura.reduce((tot, p) => tot + parseInt(p.quantidade), 0);
  const totalPreco = casrtAssinatura.reduce((tot, p) => {
    const precoNum = parseFloat(p.preco.replace("R$", "").replace(",", ".").trim());
    return tot + (isNaN(precoNum) ? 0 : precoNum * parseInt(p.quantidade));
  }, 0);

  const freteFixo = totalItens > 0 ? 7.99 : 0;
  const totalComFrete = totalPreco + freteFixo;

  const totalEl = document.getElementById("cacm-carrinho-total");
  const itensEl = document.getElementById("cacm-carrinho-itens");
  const botaoAssinar = document.querySelector(".cacm-carrinho-offcanvas__botao-assinar");

  if (totalEl) totalEl.textContent = `R$ ${totalComFrete.toFixed(2).replace(".", ",")}`;
  if (itensEl) itensEl.textContent = totalItens.toString();

  if (botaoAssinar) {
    const linkAssinar = botaoAssinar.closest("a");
    if (linkAssinar) {
      linkAssinar.href = montarUrlCarrinho();
    }
  }
}

// ==========================================
// MODAL SENSORIAL DO PRODUTO
// ==========================================
function abrirModalProduto(card) {
  const modal = document.getElementById("cacm-produto-modal");
  const modalImagem = document.getElementById("cacm-produto-modal-imagem");
  const modalTitulo = document.getElementById("cacm-produto-modal-titulo");
  const img = card.querySelector(".cacm-produto-card__imagem, .clube-produto-card__imagem");
  const titulo = card.querySelector(".cacm-produto-card__nome, .clube-produto-card__nome");

  if (modal && modalImagem && modalTitulo && img && titulo) {
    modalImagem.src = img.src;
    modalImagem.alt = img.alt || titulo.textContent;
    modalTitulo.textContent = titulo.textContent;

    const descCurta = document.getElementById("cacm-produto-modal-descricao-curta");
    const regiao = document.getElementById("cacm-produto-modal-regiao");
    const notas = document.getElementById("cacm-produto-modal-notas");
    const torra = document.getElementById("cacm-produto-modal-torra");
    const tipo = document.getElementById("cacm-produto-modal-tipo");

    if (descCurta) descCurta.innerHTML = `<p>${card.getAttribute("data-descricao-curta") || "Café 100% arábica de origem controlada."}</p>`;
    if (regiao) regiao.textContent = card.getAttribute("data-regiao") || "Brasil";
    if (notas) notas.textContent = card.getAttribute("data-notas-sensoriais") || "Notas Especiais";
    if (torra) torra.textContent = card.getAttribute("data-torra") || "Média";
    if (tipo) tipo.textContent = card.getAttribute("data-variedade") || "100% Arábica";

    modal.classList.add("show");
    document.body.style.overflow = "hidden";
  }
}

function fecharModalProduto() {
  const modal = document.getElementById("cacm-produto-modal");
  if (modal) {
    modal.classList.remove("show");
    document.body.style.overflow = "";
  }
}

// ==========================================
// CALCULADORA DE CONSUMO
// ==========================================
const dadosRecomendacao = {
  1: {
    graoMoido: "2 pacotes",
    capsula: "3 caixas",
    drip: "3 caixas",
    textoHeader: "Para você que consome 1 xícara por dia o recomendado é:"
  },
  2: {
    graoMoido: "3 pacotes",
    capsula: "6 caixas",
    drip: "6 caixas",
    textoHeader: "Para você que consome 2 xícaras por dia o recomendado é:"
  },
  3: {
    graoMoido: "4 pacotes",
    capsula: "9 caixas",
    drip: "9 caixas",
    textoHeader: "Para você que consome 3 xícaras por dia o recomendado é:"
  },
  4: {
    graoMoido: "5 pacotes",
    capsula: "12 caixas",
    drip: "12 caixas",
    textoHeader: "Para você que consome 4+ xícaras por dia o recomendado é:"
  }
};

function configurarCalculadora() {
  const botoesDose = document.querySelectorAll(".clube-dose-btn");
  const headerResultado = document.getElementById("clube-calc-header");
  const qtdGraoMoido = document.getElementById("clube-calc-grao-moido");
  const qtdCapsula = document.getElementById("clube-calc-capsula");
  const qtdDrip = document.getElementById("clube-calc-drip");
  const blocoAnual = document.getElementById("clube-calc-anual");

  const aplicarDose = (dose) => {
    const config = dadosRecomendacao[dose] || dadosRecomendacao[1];
    if (headerResultado) headerResultado.textContent = config.textoHeader;
    if (qtdGraoMoido) qtdGraoMoido.textContent = config.graoMoido;
    if (qtdCapsula) qtdCapsula.textContent = config.capsula;
    if (qtdDrip) qtdDrip.textContent = config.drip;
    if (blocoAnual) blocoAnual.hidden = dose !== "4";
  };

  botoesDose.forEach((btn) => {
    btn.addEventListener("click", () => {
      botoesDose.forEach((b) => b.classList.remove("active"));
      btn.classList.add("active");
      aplicarDose(btn.getAttribute("data-dose") || "1");
    });
  });
}

// ==========================================
// TABS DO CATÁLOGO DE CAFÉS
// ==========================================
function hashTabId() {
  const hash = (window.location.hash || "").replace(/^#/, "");
  if (!hash) return "";
  if (hash.startsWith("tab-")) return hash.slice(4);
  return hash;
}

function ativarAbaCatalogo(section, targetTab) {
  if (!targetTab) return false;
  const tabBtns = section.querySelectorAll(".clube-tab-btn");
  const tabPanes = section.querySelectorAll(".clube-tab-pane");
  const targetPane = section.querySelector(`#tab-${targetTab}`);
  const targetBtn = section.querySelector(`.clube-tab-btn[data-tab="${targetTab}"]`);
  if (!targetPane || !targetBtn) return false;

  tabBtns.forEach((b) => b.classList.remove("active"));
  tabPanes.forEach((p) => p.classList.remove("active"));
  targetBtn.classList.add("active");
  targetPane.classList.add("active");
  return true;
}

function aplicarHashCatalogo() {
  const tabId = hashTabId();
  if (!tabId) return;

  document.querySelectorAll(".clube-catalogo-section").forEach((section) => {
    if (!ativarAbaCatalogo(section, tabId)) return;
    section.scrollIntoView({ behavior: "smooth", block: "start" });
  });
}

function configurarTabsCatalogo() {
  document.querySelectorAll(".clube-catalogo-section").forEach((section) => {
    const tabBtns = section.querySelectorAll(".clube-tab-btn");

    tabBtns.forEach((btn) => {
      btn.addEventListener("click", () => {
        ativarAbaCatalogo(section, btn.getAttribute("data-tab"));
      });
    });
  });

  aplicarHashCatalogo();
  window.addEventListener("hashchange", aplicarHashCatalogo);
}

// ==========================================
// INICIALIZAÇÃO E EVENTOS
// ==========================================
document.addEventListener("DOMContentLoaded", () => {
  casrtAssinatura = recuperarCarrinhoDoSessionStorage();
  atualizarMinicart();
  configurarCalculadora();
  configurarTabsCatalogo();
  configurarJornadaAnual();

  // BOTOES DE QUANTIDADE NOS CARDS
  document.querySelectorAll(".cacm-produto-card__quantidade-botao, .clube-produto-card__quantidade-botao").forEach((btn) => {
    btn.addEventListener("click", () => {
      const container = btn.closest(".cacm-produto-card__quantidade-container, .clube-produto-card__quantidade-container");
      const valorEl = container?.querySelector(".cacm-produto-card__quantidade-valor, .clube-produto-card__quantidade-valor");
      let valor = parseInt(valorEl?.textContent || "1");
      if (btn.textContent.trim() === "+") {
        valor += 1;
      } else if (btn.textContent.trim() === "-") {
        valor = Math.max(1, valor - 1);
      }
      if (valorEl) valorEl.textContent = valor.toString();
    });
  });

  // BOTOES ASSINAR / ADICIONAR NOS CARDS
  document.querySelectorAll(".cacm-produto-card__botao-assinar, .clube-produto-card__botao-assinar").forEach((btn) => {
    btn.addEventListener("click", () => {
      const card = btn.closest(".cacm-produto-card, .clube-produto-card");
      if (!card) return;

      const id = card.getAttribute("data-id") || "";
      const nome = card.querySelector(".cacm-produto-card__nome, .clube-produto-card__nome")?.textContent?.trim() || "";
      const preco = card.querySelector(".cacm-produto-card__preco-atual, .clube-produto-card__preco-atual")?.textContent?.trim() || "";
      const precoOriginal = card.querySelector(".cacm-produto-card__preco-original, .clube-produto-card__preco-original")?.textContent?.trim() || "";
      const imagem = card.querySelector(".cacm-produto-card__imagem, .clube-produto-card__imagem")?.getAttribute("src") || "";
      const qtdCard = parseInt(card.querySelector(".cacm-produto-card__quantidade-valor, .clube-produto-card__quantidade-valor")?.textContent || "1");

      const itemExistente = casrtAssinatura.find((p) => p.id === id);
      if (itemExistente) {
        itemExistente.quantidade = (parseInt(itemExistente.quantidade) + qtdCard).toString();
      } else {
        casrtAssinatura.push(new Produto(id, nome, preco, precoOriginal, imagem, qtdCard.toString()));
      }

      salvarCarrinhoNoSessionStorage();
      mostrarToast(`"${nome}" adicionado!`);
      desabilitarBotaoTemporariamente(btn);
      mostrarMinicart();
    });
  });

  // CLIQUES NA IMAGEM / LUPA PARA ABRIR MODAL
  document.querySelectorAll(".cacm-produto-card, .clube-produto-card").forEach((card) => {
    const imgContainer = card.querySelector(".cacm-produto-card__imagem-container, .clube-produto-card__imagem-container");
    const nomeEl = card.querySelector(".cacm-produto-card__nome, .clube-produto-card__nome");
    const lupa = card.querySelector(".cacm-produto-card__lupa-overlay, .clube-produto-card__lupa-overlay");

    [imgContainer, nomeEl, lupa].forEach((el) => {
      if (el) {
        el.addEventListener("click", (e) => {
          if (!e.target.closest("button")) {
            abrirModalProduto(card);
          }
        });
      }
    });
  });

  // EVENTOS DO HEADER & MINICART & OFFCANVAS
  const btnHeaderCarrinho = document.getElementById("cacm-header-carrinho-botao");
  if (btnHeaderCarrinho) btnHeaderCarrinho.addEventListener("click", abrirCarrinho);

  const btnVerCarrinho = document.querySelector(".cacm-minicartassinatura__botao");
  if (btnVerCarrinho) {
    btnVerCarrinho.addEventListener("click", (e) => {
      e.preventDefault();
      abrirCarrinho();
    });
  }

  const btnFecharMinicart = document.querySelector(".cacm-minicartassinatura__fechar");
  if (btnFecharMinicart) btnFecharMinicart.addEventListener("click", fecharMinicart);

  const btnFecharCarrinho = document.getElementById("cacm-carrinho-fechar");
  if (btnFecharCarrinho) btnFecharCarrinho.addEventListener("click", fecharCarrinho);

  const overlayCarrinho = document.querySelector(".cacm-carrinho-offcanvas__overlay");
  if (overlayCarrinho) overlayCarrinho.addEventListener("click", fecharCarrinho);

  const btnFecharModal = document.getElementById("cacm-produto-modal-fechar");
  if (btnFecharModal) btnFecharModal.addEventListener("click", fecharModalProduto);

  const overlayModal = document.querySelector(".cacm-produto-modal__overlay");
  if (overlayModal) overlayModal.addEventListener("click", fecharModalProduto);

  document.addEventListener("keydown", (e) => {
    if (e.key === "Escape") {
      fecharModalProduto();
      fecharCarrinho();
      fecharPopupEspecial();
    }
  });
});
